/**
 * Time zones offered in the workspace settings.
 *
 * Canada only, because PRODUCT.md §7 says the MVP targets Canadian users and a list of four
 * hundred IANA zones is unusable on a phone. The workspace's current zone is always included
 * even if it is not on this list, so a value set elsewhere — by an import, or by a later release
 * that opens other countries — is never silently replaced by picking the form up and putting it
 * down again.
 */

export const CANADIAN_TIME_ZONES = [
  "America/St_Johns",
  "America/Halifax",
  "America/Moncton",
  "America/Toronto",
  "America/Winnipeg",
  "America/Regina",
  "America/Edmonton",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Iqaluit",
  "America/Dawson_Creek",
] as const;

export function timeZoneOptions(current: string | undefined): string[] {
  const zones: string[] = [...CANADIAN_TIME_ZONES];
  if (current && !zones.includes(current)) zones.unshift(current);
  return zones;
}

/** "Toronto (EST)" — the city, plus whatever the browser calls the offset today. */
export function timeZoneLabel(zone: string): string {
  const city = zone.split("/").pop()?.replaceAll("_", " ") ?? zone;
  try {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: zone,
      timeZoneName: "short",
    }).formatToParts(new Date());
    const abbreviation = parts.find((part) => part.type === "timeZoneName")?.value;
    return abbreviation ? `${city} (${abbreviation})` : city;
  } catch {
    // An unknown zone from the server should still be selectable rather than crash the page.
    return city;
  }
}
